<template>
  <div
    class="list-group-item flex items-center w-full justify-between p-xs border border-(--border-subtle) rounded-md"
    :class="{ 'cursor-move': !noDrag }"
  >
    <div class="flex w-full items-center">
      <i v-show="!noDrag" class="i-drag" />
      <p :class="{ 'ml-4': noDrag }">{{ role }}</p>
    </div>
    <TagComponent
      v-if="level"
      :value="level"
      :variant="(level.toLowerCase() as any)"
      class-name="rounded-xsm font-bold capitalize text-md"
    />
  </div>
</template>

<script setup lang="ts">
import TagComponent from '@/components/ui/tag/TagComponent.vue';
defineProps<{
  role: string;
  level: "Gold" | "Silver" | "Bronze" | "gold" | "silver" | "bronze" | null; // hack, to support uppercase and lowercase, should be more strict, only lowercase for example
  noDrag?: boolean;
}>();
</script>
